import { observable, action, makeObservable } from 'mobx'

import ganApi from '@client/api/gan'

export class CustomBlocksModel {
  @observable blocks = []
  @observable error = false
  @observable loading = false
  @observable hasBlocks = false

  constructor() {
    makeObservable(this)
  }

  @action setBlocks = (blocks) => {
    this.blocks = blocks
  }

  @action setHasBlocks = (hasBlocks) => {
    this.hasBlocks = hasBlocks
  }

  // The kind and search of the last load, so reload() can repeat it.
  lastKind = undefined
  lastSearch = undefined

  @action fetchBlocks = async (kind, search = undefined) => {
    this.lastKind = kind
    this.lastSearch = search
    this.loading = true
    this.error = false
    let response
    try {
      response = await ganApi.getBlocks({ search, kind })
    } catch (e) {
      console.error(e)
    }
    if (response && response.results) {
      this.setBlocks(response.results)
      if (!search && this.blocks.length) {
        this.setHasBlocks(true)
      } else if (!search && !this.blocks.length) {
        this.setHasBlocks(false)
      }
    } else {
      this.setError(true)
    }
    this.setLoading(false)
  }

  // Reloads the list as the user last saw it, keeping their search, e.g.
  // after dropping saved content that was deleted elsewhere (FE-1489).
  reload = () => {
    if (this.lastKind === undefined) {
      return Promise.resolve()
    }
    return this.fetchBlocks(this.lastKind, this.lastSearch)
  }

  @action setError = (error) => {
    this.error = error
  }

  @action setLoading = (loading) => {
    this.loading = loading
  }

  // Rejects when the delete failed, so the caller can say so; the block stays
  // in the list (FE-1489). A 404 means it's already gone, e.g. deleted in
  // another tab, so it's dropped from the list like a successful delete.
  @action removeBlock = async (id) => {
    this.setLoading(true)
    try {
      await ganApi.deleteBlock(id)
    } catch (e) {
      if (e.status !== 404) {
        this.setLoading(false)
        throw e
      }
    }
    this.setBlocks(this.blocks.filter((item) => item.id !== id))
    if (!this.blocks.length) {
      this.setHasBlocks(false)
    }
    this.setLoading(false)
  }
}

export const customBlocksModel = new CustomBlocksModel()
export const fetchBlocks = customBlocksModel.fetchBlocks
export const removeBlock = customBlocksModel.removeBlock
export const reloadBlocks = customBlocksModel.reload
